import React from 'react';
import { useSelector } from 'react-redux';

import UsageTrendChart from './UsageTrendChart';
import ErrorStateWithReload from '../../../../../components/ErrorStateWithReload';
import { usageTrendsSelector } from '../../../selectors';

const UsageTrend = () => {
  const { settings, data } = useSelector(usageTrendsSelector);

  if (settings.error) return <ErrorStateWithReload className="py-xl" />;

  return (
    <div className="usage-trend">
      <header className="section-body-header">
        <div className="section-body-header__left">
          <h4 className="section-body-header__title">Usage Frequency Trend</h4>
          <p className="section-body-header__description">
            Shows the share of all users in the panel that falls into each AI usage segment over time.
          </p>
        </div>
      </header>
      <UsageTrendChart isPending={settings.pending} series={data.time_series} />
    </div>
  );
};

export default UsageTrend;
